import { createSelector } from 'reselect';
import { ISystemStatusState } from 'types/systemStatus.types';

const getSystemStatusState = (state: { systemStatus: ISystemStatusState }) => state.systemStatus;

export const systemStatusSelector = createSelector(
  [getSystemStatusState],
  (systemStatus) => systemStatus?.item,
);

export const isMaintenanceModeSelector = createSelector(
  [systemStatusSelector],
  (status) => !!status?.maintenanceMode,
);

export const isSystemStatusLoadingSelector = createSelector(
  [getSystemStatusState],
  (systemStatus) => systemStatus.loading,
);
